<template>
  <Menu class="site-menu" :selectedKeys="selectedKeys" :openKeys="openKeys" mode="inline" @openChange="onOpenChange">
    <template v-for="obj in menus">
      <!-- 一级菜单没有子菜单 -->
      <MenuItem :key="obj.id" v-if="!obj?.childs?.length" @click="menuClick(obj)">
        <template #icon> <i class="iconfont icon-a-21" :class="obj.icon"></i></template>
        {{ $lang(obj.name) }}
      </MenuItem>
      <template v-else>
        <SubMenu :key="obj.id">
          <template #icon><i class="iconfont" :class="obj.icon"></i></template>
          <template #title>{{ $lang(obj.name) }}</template>
          <MenuItem
            v-for="list in obj.childs"
            :style="{ display: list?.isShow?.id === 'ON' ? 'block' : 'none' }"
            :key="list.id"
            @click="menuClick(list)"
            >{{ $lang(list.name) }}</MenuItem
          >
          <!-- <template >
            v-if="list?.isShow?.id === 'ON' "
          </template> -->
        </SubMenu>
      </template>
    </template>
  </Menu>
</template>

<script lang="ts" setup name="Menus">
  import { computed, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { Menu, MenuItem, SubMenu } from 'ant-design-vue'
  import { useSettingStore, useAuthStore } from '@jms/store'
  // import { getMenus } from './menus'
  const authStore = useAuthStore()
  const menus = computed(() => authStore.menu)
  const settingStore = useSettingStore()
  const selectedKeys = computed(() => settingStore.getSelectedKeys)
  const router = useRouter()
  const menuClick = (item: any) => {
    router.replace(item.path!)
  }
  /**所有一级导航的id集合 */
  const rootSubmenuKeys = computed(() => menus.value.map((msg) => msg.id))
  /* 默认展开导航 */
  const openKeys = ref([]) as any
  const onOpenChange = (openChangeKey: string[]) => {
    const latestOpenKey = openChangeKey.find((key: any) => openKeys.value.indexOf(key) === -1) as any
    if (rootSubmenuKeys.value.indexOf(latestOpenKey!) === -1) {
      openKeys.value = openChangeKey
    } else {
      openKeys.value = latestOpenKey ? [latestOpenKey] : []
    }
  }
</script>
<style lang="less" scoped>
  .ant-menu {
    :deep(&-item) {
      &:hover {
        background-color: @menu-item-hover-bg;
      }
      &::after {
        left: 0;
        right: inherit;
      }
    }
    :deep(&-sub.ant-menu-inline) {
      background-color: @white;
    }
    .iconfont {
      font-size: 16px;
    }
    .icon-shouqi {
      .fs-16;
      transform: scale(0.5);
      color: #9499a3;
    }
    .ant-menu-submenu {
      &-selected,
      &-active {
        .icon-shouqi {
          color: @primary-color;
        }
      }
    }
  }
</style>
